/**
 * FeaturePlate
 * -----------------------------------------------------------
 * Brass-cornered parchment plate that pins to the right side
 * of a CinematicHero (locked R5-M1 design).
 *
 * Usage:
 *   <FeaturePlate
 *     badge="Tonight's Featured"
 *     title="The Salted Lantern"
 *     meta="Gastropub · Live Music · ★ 4.8"
 *     blurb="Candlelit gastropub with rum-glazed mahi…"
 *     ctaLabel="Reserve a Table →"
 *     ctaHref="/business-listings/salted-lantern"
 *   />
 *
 * Either `ctaHref` (renders <a>) or `onCtaClick` (renders
 * <button>) may be provided. The brass diamond pin in the
 * top-right is rendered automatically; pass `pin={false}`
 * to suppress it.
 */
import React from 'react';

export function FeaturePlate({
  badge,
  title,
  meta,
  blurb,
  ctaLabel,
  ctaHref,
  onCtaClick,
  secondaryLabel,
  onSecondaryClick,
  pin = true,
  className = '',
  ...rest
}) {
  const cls = ['r5-feature-card', className].filter(Boolean).join(' ');

  let cta = null;
  if (ctaLabel) {
    if (ctaHref) {
      cta = (
        <a className="r5-feature-card__cta" href={ctaHref}>
          {ctaLabel}
        </a>
      );
    } else if (onCtaClick) {
      cta = (
        <button
          type="button"
          className="r5-feature-card__cta"
          onClick={onCtaClick}
        >
          {ctaLabel}
        </button>
      );
    }
  }

  const secondary = secondaryLabel && onSecondaryClick ? (
    <button
      type="button"
      className="r5-feature-card__secondary"
      onClick={onSecondaryClick}
    >
      {secondaryLabel}
    </button>
  ) : null;

  return (
    <aside className={cls} {...rest}>
      {pin && <span className="r5-feature-card__pin" aria-hidden="true" />}
      {badge && <span className="r5-feature-card__badge">{badge}</span>}
      {title && <h3 className="r5-feature-card__title">{title}</h3>}
      {meta && <p className="r5-feature-card__meta">{meta}</p>}
      {blurb && <p className="r5-feature-card__blurb">{blurb}</p>}
      {cta}
      {secondary}
    </aside>
  );
}

export default FeaturePlate;
